module.exports = __webpack_public_path__ + "img/scene_bg.5f7ce04a.png";